import React, { useState, useRef } from "react"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"
import isNil from "ramda/src/isNil"
import isEmpty from "ramda/src/isEmpty"
import { connect } from "react-redux"
import { bool, func, object } from "prop-types"
import moment from "moment"

import Typograph from "components/Typograph"
import ModernModal from "shared/components/ModernModal"
import ContentDemand from "./ContentDemand"
import EmailModal from "components/ModernEmailModal"
import { showToast } from "components/Toast"

import {
  downloadRequestDetails,
  sendMailRequestDetails,
  downloadDemandsFiles,
  downloadAudio
} from "services/state/repair/action"
import { buildSendMailParams } from "scenes/IncidentManager/incident-manager-helpers"
import { downloadFile } from "services/utils/downloadAudio"
import {
  DOWNLOAD_REQUEST_DETAIL_FAIL,
  SEND_MAIL_REQUEST_DETAIL_FAIL
} from "services/state/action-types"

const RequestTrackingForm = ({
  isOpen,
  onClose,
  customer,
  demand,
  customerDemands,
  downloadRequestDetails,
  sendMailRequestDetails,
  t
}) => {
  const isAudioContent =
    demand && !isNil(demand.fileAudioURL) && !isEmpty(demand.fileAudioURL)

  const [isOpenEmail, setOpenModalEmail] = useState(false)
  const audioRef = useRef(null)

  const download = (protocol) => {
    if (!isNil(demand.fileAudioURL) && !isEmpty(demand.fileAudioURL)) {
      downloadFile(audioRef.current, {
        name: `${demand.protocolNumber}.mp3`
      })
    } else {
      const newKey = []
      newKey.push(protocol)

      const objKey = {
        keys: newKey
      }

      const startDate = moment().subtract(6, "months").format("DD/MM/YYYY")
      const endDate = moment().format("DD/MM/YYYY")

      const params = {
        startDate,
        endDate,
        protocol: objKey
      }

      downloadRequestDetails(params, (response) => {
        const errorRequest = response.type === DOWNLOAD_REQUEST_DETAIL_FAIL

        showToast({
          message: errorRequest
            ? "Cliente, ocorreu um erro em  seu download! Tente novamente dentro de alguns minutos."
            : "Cliente, o seu download foi realizado com sucesso! Você já consegue acessar o arquivo em seu dispositivo.",
          type: errorRequest ? "error" : "sucess"
        })
      })
    }
  }

  const sendForMail = (email) => {
    const params = buildSendMailParams(
      { email },
      customer,
      demand.protocolNumber
    )

    sendMailRequestDetails(params, (response) => {
      setOpenModalEmail(false)

      const errorRequest = response.type === SEND_MAIL_REQUEST_DETAIL_FAIL

      showToast({
        message: errorRequest
          ? "Cliente, ocorreu um erro ao enviar seu protocolo por e-mail! Tente novamente dentro de alguns minutos."
          : "Cliente, o seu protocolo foi enviado para e-mail com sucesso!",
        type: errorRequest ? "error" : "sucess"
      })
    })
  }

  const openModalEmail = () => {
    setOpenModalEmail(true)
  }

  const onCancelEmail = () => {
    setOpenModalEmail(false)
  }

  return (
    <ModernModal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={() => openModalEmail(demand.protocolNumber)}
      onConfirm={() => download(demand.protocolNumber)}
      cancelButtonText="Enviar por e-mail"
      cancelButtonProps={{
        toLinkBtn: true
      }}
      confirmButtonText={isAudioContent ? "Baixar audio" : "Baixar"}
    >
      <Typograph preset="h2" color="outer_space">
        {t("MSG_0246")}
      </Typograph>
      <ContentDemand
        innerRef={audioRef}
        t={t}
        demand={demand}
        customerDemands={customerDemands}
      />
      <EmailModal
        title={t("MSG_0140")}
        isOpen={isOpenEmail}
        onSubmit={sendForMail}
        email={customer.email}
        onClose={onCancelEmail}
      />
    </ModernModal>
  )
}

RequestTrackingForm.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  customer: object,
  demand: object,
  customerDemands: object,
  downloadRequestDetails: func,
  sendMailRequestDetails: func,
  t: func
}

const mapStateToProps = ({ repair, customer }) => ({
  loading: repair.loading,
  customer: customer.data
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    downloadRequestDetails,
    sendMailRequestDetails,
    downloadDemandsFiles,
    downloadAudio
  })
)

export default enhance(RequestTrackingForm)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RequestTrackingModal/index.js